let sequentialId = 0

export const increaseSequentialId = () => {
  sequentialId += 1
  return sequentialId
}
